<template>
    <div>
        <sav-template title="" :back-button="false" :navigation-bar="false">
            <div v-html="$t('bienvenue.description')"></div>
            <div class="my-rounded bg-white shadow p-6 mt-4">
                <router-link :to="{ name: 'user.login'}" class="text-gray-900" style="text-decoration: none !important;">
                    <div class="flex justify-between items-center p-6 hover:bg-gray-50 rounded-b-xl duration-200">
                        <div>
                            <b>{{$t('bienvenue.me_connecter')}}</b>
                            <small class="block text-gray-600">{{$t('bienvenue.je_possede_deja_un_compte')}}</small>
                        </div>
                        <i class="fas fa-caret-right"></i>
                    </div>
                </router-link>
                <router-link :to="{ name: 'user.login.actors'}" class="text-gray-900" style="text-decoration: none !important;">
                    <div class="flex justify-between items-center p-6 hover:bg-gray-50 rounded-b-xl duration-200">
                        <div class="pr-4">
                            <b>{{$t('bienvenue.m_inscrire')}}</b>
                            <small class="block text-gray-600">{{$t('bienvenue.je_ne_possede_pas_encore_de_compte')}}</small>
                        </div>
                        <i class="fas fa-caret-right"></i>
                    </div>
                </router-link>
            </div>
        </sav-template>
    </div>
</template>

<script>
export default {
    mounted() {
        localStorage.removeItem('form-data')
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/Welcome.vue